import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {ToastsContainer, ToastsStore, ToastsContainerPosition} from 'react-toasts';
import Toastr from "../../../Validations/Toastr";
import {bindActionCreators} from 'redux';
import {withRouter} from "react-router-dom";
import moment from 'moment';
import {fetchUserProfile} from "../../../../actions/userAction";
import iconPath from "./../../../../helpers/iconHelper";
import  ViewmoreModal   from "./ViewmoreModal";
import { encrypt , decrypt } from "../../../../helpers/CryptoJs";
import { getlanguagelist } from "../../../../helpers/changelanguage";
import { isThisSecond } from 'date-fns';
import { confirmAlert } from 'react-confirm-alert';

class UserAboutView extends Component {

  constructor(props) {
    super(props);
    
    this.state = {
      urlId           : this.props.urlId,
      userProfile     : {},
      is_control      : false,
      modal_open      : false,
      viewmore_data   : [],
      viewmore_privacy: null,
      viewmore_title  : null    
    }
    this.fetchProfile = this.fetchProfile.bind(this);
    this.handleOpen   = this.handleOpen.bind(this);
    this.handleClose  = this.handleClose.bind(this);
    this.changeview   = this.changeview.bind(this);
  }
  
  componentDidMount() {
    if(this.props.changeTab.usertabindex == 3){
       this.fetchProfile();
    }
  }
  
  fetchProfile(){
    this.props.fetchUserProfile(this.state);
  }
  
  handleOpen(data,privacy,header){
    this.setState({
        modal_open       : true,   
        viewmore_data    : data,
        viewmore_privacy : privacy,
        viewmore_title   : header   
    });
  };

  handleClose(){
    this.setState({
        modal_open : false
    });
  };

  UNSAFE_componentWillReceiveProps(nextProps,prevProps){

    let  languagelist    = getlanguagelist();
    if(Object.keys(nextProps.userprofiledetail.profile).length > 0){
        let view = '';
        if(nextProps.currentUserDetails.id == decrypt(window.location.href.split('/')[4])){
            view = "ON"
        }else{
          if(nextProps.userFriendDetails.fetch_profile_details != undefined){
            view = nextProps.userFriendDetails.fetch_profile_details
          }else{
            view = 'OFF'
          }
        }
        
        
        if(view == 'OFF'){
            if(decrypt(window.location.href.split('/')[4]) == nextProps.userFriendDetails.id){
                confirmAlert({
                    title: languagelist.cofirm,
                    message: languagelist.privateprofilealert,
                    buttons: [
                      {
                        label: languagelist.dialogbuttonok,
                        onClick: () => {
                         window.location.reload();
                        }
                      }
                    ]
                  });
            }
        }else{
            this.setState({
                userProfile : nextProps.userprofiledetail.profile,
                is_control  : (nextProps.currentUserDetails.id == this.state.urlId) ? true : false
            });
        }
        
    }
    if((nextProps.changeTab.usertabindex == 3) && (this.props.changeTab.usertabindex != nextProps.changeTab.usertabindex)){
        
        this.fetchProfile();
    }
    if((decrypt(window.location.href.split('/')[4]) != this.props.urlId) && (this.props.changeTab.usertabindex == nextProps.changeTab.usertabindex)){
       
        this.setState({
            urlId : decrypt(window.location.href.split('/')[4])
        },function(){
            this.fetchProfile();
        });
    } 
  }

  changeview(type){
    this.props.changeview(type);
  }
  
  
  render() {
    let userProfile      = this.state.userProfile || {};
    let countuserProfile = Object.keys(userProfile).length;
    let viewControl      = this.state.is_control;
    let  languagelist    = getlanguagelist();
    let title            = ''; 
    let gender           = '';
   
    if(countuserProfile > 0 &&  userProfile.title.value == "Mr."){
        title = languagelist.mr;
    }else if(countuserProfile > 0 &&  userProfile.title.value == "Ms."){
        title = languagelist.ms;
    }else if(countuserProfile > 0 &&  userProfile.title.value == "Mrs."){
        title = languagelist.mrs;
    }else if(countuserProfile > 0 &&  userProfile.title.value == "Dr."){
        title = languagelist.dr;
    }else if(countuserProfile > 0 &&  userProfile.title.value == "Prof."){
        title = languagelist.prof;
    }else{
        title = '';
    }

    if(countuserProfile > 0 &&  userProfile.gender.value == "F"){
        gender = languagelist.female;
    }else if(countuserProfile > 0 &&  userProfile.gender.value == "M"){
        gender = languagelist.male;
    }else if(countuserProfile > 0 &&  userProfile.gender.value == "T"){
        gender = languagelist.otherg;
    }else{
        gender = ''; 
    }

    return (
        <div>
        <div className="row">
           
            {/* About me */}
            <div className="col-xs-12 col-sm-6 col-md-3 col-lg-3 left_area">
                <div className="left_fixt">
                    <div className="post_box known">
                        <h3>{languagelist.description}</h3>
                        <div className="description_box">
                            <p>{(countuserProfile > 0) ? userProfile.about_me.value : ''}
                        </p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-9 post_area">
                <div className="row margin-row">
                {/* personal details */}
                <div className="post_box known">
                    <h3>
                        <span className="pull-left">{languagelist.personalinfo}</span> 
                        <span className="pull-right"> 
                            {viewControl ?  <button className="btn_3" onClick={()=>this.changeview('edit')}><i className="fa fa-edit"></i> {languagelist.edit} </button> : null}
                        </span>
                    </h3>
                    
                   
                    <div className="clr20"></div>
                    {((countuserProfile > 0) && (userProfile.title.is_hidden == 0)) ?
                    <div className="col-lg-6">
                        <div className="infi_fild">
                            <img className="pull-left" src="/assets/images/user_fild_icon.png" />
                            <div className="input_mid pull-left">
                                <label>{languagelist.title}</label> 
                                  <input type="text" value={title} readOnly />
                                 
                             
                            </div>
                            {viewControl ? <a className="pull-right web_button"><img src={(countuserProfile > 0) ? iconPath[userProfile.title.privacy] : ''} /></a> : null}
                            <div className="clearfix"></div>
                        </div>
                    </div>
                    : null}
                    {((countuserProfile > 0) && (userProfile.first_name.is_hidden == 0)) ?
                    <div className="col-lg-6">
                        <div className="infi_fild">
                            <img className="pull-left" src="/assets/images/user_fild_icon.png" />
                            <div className="input_mid pull-left">
                                <label>{languagelist.fname}</label>
                                <input type="text" value={(countuserProfile > 0) ? userProfile.first_name.value : ''} readOnly />
                            </div>
                            {viewControl ? <a className="pull-right web_button"><img src={(countuserProfile > 0) ? iconPath[userProfile.first_name.privacy] : ''} /></a> : null}
                            <div className="clearfix"></div>
                        </div>
                    </div>
                    : null}
                    {((countuserProfile > 0) && (userProfile.last_name.is_hidden == 0))  ?
                    <div className="col-lg-6">
                        <div className="infi_fild">
                            <img className="pull-left" src="/assets/images/user_fild_icon.png" />
                            <div className="input_mid pull-left">
                                <label>{languagelist.lname}</label>
                                <input type="text" value={(countuserProfile > 0) ? userProfile.last_name.value : ''} readOnly />
                            </div>
                            {viewControl ? <a className="pull-right web_button"><img src={(countuserProfile > 0) ? iconPath[userProfile.last_name.privacy] : ''} /></a> : null}
                            <div className="clearfix"></div>
                        </div>
                    </div>
                    : null}
                     {((countuserProfile > 0) && (userProfile.dob.is_hidden == 0))  ?
                    <div className="col-lg-6">
                        <div className="infi_fild">
                            <img className="pull-left" src="/assets/images/user_dob_icon.png" />
                            <div className="input_mid pull-left">
                                <label>{languagelist.dob}</label>
                                <input type="text" value={((countuserProfile > 0) && (userProfile.dob.value != '0000-00-00')&& (userProfile.dob.value != '')) ? moment(userProfile.dob.value).format('MMM Do YYYY') : ''} readOnly />
                            </div>
                            {viewControl ? <a className="pull-right web_button"><img src={(countuserProfile > 0) ? iconPath[userProfile.dob.privacy] : ''} /></a> : null }
                            <div className="clearfix"></div>
                        </div>
                    </div>
                    : null}
                    {((countuserProfile > 0) && (userProfile.dob.is_hidden == 0))  ?
                    <div className="col-lg-6">
                        <div className="infi_fild">
                            <img className="pull-left" src="/assets/images/user_gender_icon.png" />
                            <div className="input_mid pull-left">
                                <label>{languagelist.gender}</label>
                                <input type="text" value={gender} readOnly />
                            </div>
                            {viewControl ? <a className="pull-right web_button"><img src={(countuserProfile > 0) ? iconPath[userProfile.gender.privacy] : ''} /></a> : null }
                            <div className="clearfix"></div>
                        </div>
                    </div>
                    : null}
                    <div className="clr20"></div>
                </div>
                           

                {/* contact details */}
                <div className="post_box known">
                    <h3>{languagelist.contactd}</h3>
                    <div className="clr20"></div>
                    {/* ((countuserProfile > 0) && (userProfile.phone.is_hidden == 0))  ?   
                    <div className="col-lg-6">
                        <div className="infi_fild">
                            <img className="pull-left" src="/assets/images/user_phone_icon.png" />
                            <div className="input_mid pull-left">
                                <label>{languagelist.mobile}</label>
                                <input type="text" value={(countuserProfile > 0) ? `${userProfile.phone_country_code} ${userProfile.phone.value}` : ''} readOnly />
                            </div>
                            {viewControl ? <a className="pull-right web_button"><img src={(countuserProfile > 0) ? iconPath[userProfile.phone.privacy] : ''} /></a> : null }
                           
                            <div className="clearfix"></div>
                        </div>
                    </div> 
                    : null */}
                    {((countuserProfile > 0) && (userProfile.email.is_hidden == 0))  ?   
                    <div className="col-lg-6">
                        <div className="infi_fild">
                            <img className="pull-left" src="/assets/images/user_fild_icon.png" />
                            <div className="input_mid pull-left">
                                <label>{languagelist.email}</label>
                                <input type="text" value={(countuserProfile > 0) ? userProfile.email.value : ''} readOnly/>
                            </div>
                            {viewControl ?  <a className="pull-right web_button"><img src={(countuserProfile > 0) ? iconPath[userProfile.email.privacy] : ''} /></a> : null }
                            <div className="clearfix"></div>
                        </div>
                    </div>
                    : null }
                    <div className="clr20"></div>
                </div>

                {/* address details */}
                <div className="post_box known">
                    <h3>{languagelist.addressd}</h3>
                    <div className="clr20"></div>
                    {((countuserProfile > 0) && (userProfile.country_name.is_hidden == 0))  ?          
                    <div className="col-lg-6">
                        <div className="infi_fild">
                            <img className="pull-left" src="/assets/images/user_cuntry_icon.png" />
                            <div className="input_mid pull-left">
                                <label>{languagelist.country}</label>
                                <input type="text"  value={(countuserProfile > 0) ? userProfile.country_name.value : ''} readOnly/>
                            </div>
                            {viewControl ? <a className="pull-right web_button"><img src={(countuserProfile > 0) ? iconPath[userProfile.country_name.privacy] : ''}/></a> : null }
                            <div className="clearfix"></div>
                        </div>
                    </div>
                    : null }
                    {((countuserProfile > 0) && (userProfile.state.is_hidden == 0))  ?   
                    <div className="col-lg-6">
                        <div className="infi_fild">
                            <img className="pull-left" src="/assets/images/user_stat_icon.png"/>
                            <div className="input_mid pull-left">
                                <label>{languagelist.regi}</label>
                                <input type="text"  value={(countuserProfile > 0) ? userProfile.state.value : ''} readOnly/>
                            </div>
                            {viewControl ? <a className="pull-right web_button"><img src={(countuserProfile > 0) ? iconPath[userProfile.state.privacy] : ''}/></a> : null }
                            <div className="clearfix"></div>
                        </div>
                    </div>
                     : null }
                     {((countuserProfile > 0) && (userProfile.city.is_hidden == 0))  ?   
                    <div className="col-lg-6">
                        <div className="infi_fild">
                            <img className="pull-left" src="/assets/images/user_city_icon.png" />
                            <div className="input_mid pull-left">
                                <label>{languagelist.city}</label>
                                <input type="text"  value={(countuserProfile > 0) ? userProfile.city.value : ''} readOnly/>
                            </div>
                            {viewControl ? <a className="pull-right web_button"><img src={(countuserProfile > 0) ? iconPath[userProfile.city.privacy] : ''} /></a> : null }
                            <div className="clearfix"></div>
                        </div>
                    </div>
                     : null }
                     {((countuserProfile > 0) && (userProfile.zipcode.is_hidden == 0))  ?   
                    <div className="col-lg-6">
                        <div className="infi_fild">
                            <img className="pull-left" src="/assets/images/user_zif_icon.png" />
                            <div className="input_mid pull-left">
                                <label>{languagelist.zip}</label>
                                <input type="text"  value={(countuserProfile > 0) ? userProfile.zipcode.value : ''} readOnly/>
                            </div>
                            {viewControl ? <a className="pull-right web_button"><img src={(countuserProfile > 0) ? iconPath[userProfile.zipcode.privacy] : ''} /></a> : null }
                            <div className="clearfix"></div>
                        </div>
                    </div>
                    : null }
                    {((countuserProfile > 0) && (userProfile.residence_address.is_hidden == 0))  ?   
                    <div className="col-lg-6">
                        <div className="infi_fild">
                            <img className="pull-left" src="/assets/images/user_stat_icon.png" />
                            <div className="input_mid pull-left">
                                <label>{languagelist.address}</label>
                                <textarea readOnly value={(countuserProfile > 0) ? userProfile.residence_address.value : ''}></textarea>
                                {/* <input type="text"  value={(countuserProfile > 0) ? userProfile.residence_address.value : ''} readOnly/> */}
                            </div>
                            {viewControl ? <a className="pull-right web_button"><img src={(countuserProfile > 0) ? iconPath[userProfile.residence_address.privacy] : ''} /></a> : null }
                            <div className="clearfix"></div>
                        </div>
                    </div>
                    : null }
                    <div className="clr20"></div>
                </div>
                
                {/* other details */}
                {(countuserProfile > 0) && userProfile.membership == 'GOLD' 
                ? 
                <div className="post_box known">
                    <h3>{languagelist.otherd}</h3>
                    <div className="clr20"></div>
                    {((countuserProfile > 0) && (userProfile.id_number.is_hidden == 0))  ?   
                    <div className="col-lg-6">
                        <div className="infi_fild">
                            <img className="pull-left" src="/assets/images/user_idcard_icon.png" />
                            <div className="input_mid pull-left">
                                <label>{(countuserProfile > 0) ? userProfile.id_type : languagelist.idtype}</label>
                                <input type="text" value={(countuserProfile > 0) ? userProfile.id_number.value : ''} readOnly />
                            </div>
                            {viewControl ? <a className="pull-right web_button"><img src={(countuserProfile > 0) ? iconPath[userProfile.id_number.privacy] : ''}/></a> : null }
                            <div className="clearfix"></div>
                        </div>
                    </div>
                    : null }
                    {((countuserProfile > 0) && (userProfile.work.is_hidden == 0))  ?   
                    <div className="col-lg-6">
                        <div className="infi_fild">
                            <img className="pull-left" src="/assets/images/user_fild_icon.png" />
                            <div className="input_mid pull-left">
                                <label>{(countuserProfile > 0) ? userProfile.work_title : languagelist.wtitle}</label>
                                <input type="text" value={(countuserProfile > 0) ? userProfile.work.value : ''} readOnly />
                            </div>
                            {viewControl ? <a className="pull-right web_button"><img src={(countuserProfile > 0) ? iconPath[userProfile.work.privacy] : ''} /></a> : null }
                            <div className="clearfix"></div>
                        </div>
                    </div>
                    : null }
                    <div className="clr20"></div>
                </div>
                : null}

                {/* Relationship */}
                <div className="clearfix"></div>
                <div className="sochal_group">
                    <div>
                        <img src="/assets/images/relationship_icon.png" />
                    </div>

                    <div className="sochal_group_right">
                        <div className="relationship_top">
                            <h2>{languagelist.relationshp}</h2>
                            <a href="#" className="addnew_btn" style={{visibility : 'hidden'}}>+ Add New</a>
                           {/*  {(viewControl && (userProfile.total_relationship > 0)) ? <a className="pull-right web_button"><img src={((countuserProfile > 0) && (userProfile.total_relationship > 0)) ? iconPath[userProfile.relationship[0].privacy] : null }/> {((countuserProfile > 0) && (userProfile.total_relationship > 0)) ? userProfile.relationship[0].privacy : null } </a> : null } */}
                        </div>
                        {((countuserProfile > 0) && (userProfile.total_relationship > 0)) ?
                        <div className="relation_outer">
                            {   
                                (userProfile.relationship).map((relation,index) => {
                                    if(index < 3){
                                    return (
                                        
                                            <div className={(relation.membership == 'GOLD') ? 'relation_user golden_m' : 'relation_user'}  key={`relationship${index}`}>
                                                <div><img src={(relation.media_link != '') ? relation.media_link : iconPath['DEFAULTUSER']} /></div>
                                                <div>
                                                    <h4><Link to={`/user/${encrypt(relation.user_id)}`} className="frnds_box" >{relation.full_name}</Link></h4>
                                                    <p>{relation.value}</p>
                                                </div>
                                            </div>
                                        
                                    )
                                    }
                                })
                            }
                            <div className="relation_user">
                                    <p className="more_group">
                                        <strong>
                                            <a onClick={()=>this.handleOpen(userProfile.relationship,iconPath[`${userProfile.relationship[0].privacy}WHITE`],`${languagelist.relationshp}`)}> 
                                            {(userProfile.total_relationship > 3) ?
                                                `+ ${userProfile.total_relationship - 3}`
                                                :  <i style={{color:'#4189DD',fontSize: '20px'}} className="fas fa-ellipsis-v" aria-hidden="true"  onClick={()=>this.handleOpen(userProfile.relationship,iconPath[`${userProfile.relationship[0].privacy}WHITE`],'Relationship')}></i>
                                            }  
                                            </a>
                                        </strong><br/> 
                                            {(userProfile.total_relationship > 3) ?
                                                `${languagelist.more}`
                                            : null }
                                    </p>
                            </div>
                             
                        </div>
                        : null
                        }
                    </div>
                </div>
               
                 {/* Social */}
                <div className="clearfix"></div>
                <div className="sochal_group">
                    <div>
                        <img src="/assets/images/social_status.png" />
                    </div>

                    <div className="sochal_group_right">
                        <div className="relationship_top">
                            <h2>{languagelist.socialstat}</h2>
                             <a href="#" className="addnew_btn" style={{visibility : 'hidden'}}>+ Add New</a> 
                           {/*  {(viewControl && (userProfile.total_social_status > 0)) ? <a className="pull-right web_button"><img src={((countuserProfile > 0) && (userProfile.total_social_status > 0)) ? iconPath[userProfile.social_status[0].privacy] : null }/> {((countuserProfile > 0) && (userProfile.total_social_status > 0)) ? userProfile.social_status[0].privacy : null } </a> : null } */}
                        </div>
                        {((countuserProfile > 0) && (userProfile.total_social_status > 0)) ?
                        <div className="relation_outer">
                            {   
                                (userProfile.social_status).map((social,index) => {
                                    if(index < 3){
                                    return (
                                        <div className="relation_user" key={`social${index}`}>
                                            <div><img src={(social.media_link != '') ? social.media_link : ''} /></div>
                                            <div>
                                                <h4>{social.full_name}</h4>
                                                <p>{social.value}</p>
                                            </div>
                                        </div>
                                    )
                                    }
                                })
                            }
                            {/* {(userProfile.total_relationship > 3) ?
                                <div className="relation_user">
                                    <p className="more_group"><strong> +3</strong><br/> MORE</p>
                                </div>
                            :null
                            } */}
                            
                        </div>
                        : null
                        }
                    </div>
                  </div>
               
        
                {/* Education */}
                <div className="clearfix"></div>
                <div className="sochal_group">
                    <div>
                        <img src="/assets/images/education_statas.png" />
                    </div>

                    <div className="sochal_group_right">
                        <div className="relationship_top">
                            <h2>{languagelist.education}</h2>
                            <a href="#" className="addnew_btn" style={{visibility : 'hidden'}}>+ Add New</a> 
                            {/* {(viewControl && (userProfile.total_education > 0)) ? <a className="pull-right web_button"><img src={((countuserProfile > 0) && (userProfile.total_education > 0)) ? iconPath[userProfile.education[0].privacy] : null }/> {((countuserProfile > 0) && (userProfile.total_education > 0)) ? userProfile.education[0].privacy : null } </a> : null } */}
                        </div>
                        {((countuserProfile > 0) && (userProfile.total_education > 0)) ?
                        <div className="relation_outer">
                            {   
                                (userProfile.education).map((edu,index) => {
                                    if(index < 3){
                                    return (
                                        <div className="relation_user" key={`education${index}`}>
                                            <div><img src={(edu.media_link != '') ? edu.media_link : ''} /></div>
                                            <div>
                                                <h4>{edu.full_name}</h4>
                                            </div>
                                        </div>
                                    )
                                    }
                                })
                            }
                           
                            <div className="relation_user">
                                    <p className="more_group">
                                        <strong>
                                            <a onClick={()=>this.handleOpen(userProfile.education,iconPath[`${userProfile.education[0].privacy}WHITE`],`${languagelist.education}`)}> 
                                            {(userProfile.total_education > 3) ?
                                                `+ ${userProfile.total_education - 3}`
                                                :  <i style={{color:'#4189DD',fontSize: '20px'}} className="fas fa-ellipsis-v" aria-hidden="true"  onClick={()=>this.handleOpen(userProfile.education,iconPath[`${userProfile.education[0].privacy}WHITE`],'Education')}></i>
                                            }  
                                            </a>
                                            </strong><br/> 
                                            {(userProfile.total_education > 3) ?
                                                `${languagelist.more}`
                                            : null }
                                    </p>   
                            </div>
                            
                            
                        </div>
                        : null
                        }
                    </div>
                </div>            
        
                {/* Profession */}
                <div className="clearfix"></div>
                <div className="sochal_group">
                    <div>
                        <img src="/assets/images/profession_statas.png" />
                    </div>

                    <div className="sochal_group_right">
                        <div className="relationship_top">
                            <h2>{languagelist.profession}</h2>
                            <a href="#" className="addnew_btn" style={{visibility : 'hidden'}}>+ Add New</a> 
                          {/* {(viewControl && (userProfile.total_profession > 0)) ?  <a className="pull-right web_button"><img src={((countuserProfile > 0) && (userProfile.total_profession > 0)) ? iconPath[userProfile.profession[0].privacy] : null }/> {((countuserProfile > 0) && (userProfile.total_profession > 0)) ? userProfile.profession[0].privacy : null } </a> : null } */}
                        </div>
                        {((countuserProfile > 0) && (userProfile.total_profession > 0)) ?
                        <div className="relation_outer">
                            {   
                                (userProfile.profession).map((prof,index) => {
                                    if(index < 3){
                                    return (
                                        <div className="relation_user" key={`profession${index}`}>
                                            <div><img src={(prof.media_link != '') ? prof.media_link : ''} /></div>
                                            <div>
                                                <h4>{prof.full_name}</h4>
                                               
                                            </div>
                                        </div>
                                    )
                                    }
                                })
                            }
                            
                            <div className="relation_user">
                                    <p className="more_group">
                                        <strong>
                                            <a onClick={()=>this.handleOpen(userProfile.profession,iconPath[`${userProfile.profession[0].privacy}WHITE`],`${languagelist.profession}`)}> 
                                            {(userProfile.total_prof > 3) ?
                                                `+ ${userProfile.total_prof - 3}`
                                                :  <i style={{color:'#4189DD',fontSize: '20px'}} className="fas fa-ellipsis-v" aria-hidden="true"  onClick={()=>this.handleOpen(userProfile.profession,iconPath[`${userProfile.profession[0].privacy}WHITE`],'Profession')}></i>
                                            }  
                                            </a>
                                            </strong><br/> 
                                            {(userProfile.total_prof > 3) ?
                                                `${languagelist.more}`
                                            : null }
                                    </p>
                            </div>
                            
                            
                        </div>
                        : null
                        }
                    </div>
                </div>

                {/* Hobbies */}
                <div className="clearfix"></div>
                <div className="sochal_group">
                    <div>
                        <img src="/assets/images/hobbies_statas.png" />
                    </div>

                    <div className="sochal_group_right">
                        <div className="relationship_top">
                            <h2>{languagelist.hobbies}</h2>
                            <a href="#" className="addnew_btn" style={{visibility : 'hidden'}}>  + Add New</a> 
                           {/* {(viewControl && (userProfile.total_hobby > 0)) ?  <a className="pull-right web_button"><img src={((countuserProfile > 0) && (userProfile.total_hobby > 0)) ? iconPath[userProfile.hobby[0].privacy] : null }/> {((countuserProfile > 0) && (userProfile.total_hobby > 0)) ? userProfile.hobby[0].privacy : null } </a> : null } */}
                        </div>
                        {((countuserProfile > 0) && (userProfile.total_hobby > 0)) ?
                        <div className="relation_outer">
                            {   
                                (userProfile.hobby).map((hobb,index) => {
                                    if(index < 3){
                                    return (
                                        <div className="relation_user" key={`Hobbies${index}`}>
                                            <div><img src={(hobb.media_link != '') ? hobb.media_link : ''} /></div>
                                            <div>
                                                <h4>{hobb.full_name}</h4>
                                              
                                            </div>
                                        </div>
                                    )
                                    }
                                })
                            }
                            
                            <div className="relation_user">
                                    <p className="more_group">
                                        <strong>
                                            <a onClick={()=>this.handleOpen(userProfile.hobby,iconPath[`${userProfile.hobby[0].privacy}WHITE`],`${languagelist.hobbies}`)}> 
                                            {(userProfile.total_hobby > 3) ?
                                                `+ ${userProfile.total_hobby - 3}`
                                                :  <i style={{color:'#4189DD',fontSize: '20px'}} className="fas fa-ellipsis-v" aria-hidden="true" onClick={()=>this.handleOpen(userProfile.hobby,iconPath[`${userProfile.hobby[0].privacy}WHITE`],'Hobby')}></i>
                                            }  
                                            </a>
                                            </strong><br/> 
                                            {(userProfile.total_hobby > 3) ?
                                                `${languagelist.more}`
                                            : null }
                                    </p> 
                            </div>
                            
                            
                        </div>
                        : null
                        }
                    </div>
                </div>
            </div>
            </div>
        
    </div>
        <ViewmoreModal modalOpen={this.state.modal_open} viewmoreData = {this.state.viewmore_data} viewmorePrivacy = {this.state.viewmore_privacy} viewmoreTitle = {this.state.viewmore_title} handleClose={this.handleClose} viewControl={viewControl} page="view"/>
    </div>
    );
  }

}


const mapStateToProps = state => {
    return {
            currentUserDetails : state.login.user,
            changeTab          : state.activetab,
            userprofiledetail  : state.userprofiledetail,
            userFriendDetails  : state.frienddetail['friendDetail'],
            
           }
  }
  const mapDispatchToProps = dispatch => {
    return{
            fetchUserProfile: bindActionCreators(fetchUserProfile, dispatch)
          };
  }
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(UserAboutView))